export enum AuthRole {
  ADMIN = 'admin',
  CUSTOMER = 'customer'
}
